var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon2White(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.02 10.078l2.856 2.855-.944.943-2.854-2.855A6.002 6.002 0 01.333 6.334c0-3.313 2.688-6 6-6a6.002 6.002 0 014.687 9.744zm-1.337-.495a4.665 4.665 0 00-3.35-7.917 4.665 4.665 0 00-4.667 4.667 4.665 4.665 0 007.917 3.35l.1-.1z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/svg/search-icon-2-white.svg";
export { SvgSearchIcon2White as ReactComponent };